export default __webpack_public_path__ + "assets/images/battle-royale.9ac684a4.jpg";